/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_Benefits_SummaryInputs */

const en_directory_promotion_benefits_summary = /** @type {(inputs: Directory_Promotion_Benefits_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weekly performance summary`)
};

const zh_directory_promotion_benefits_summary = /** @type {(inputs: Directory_Promotion_Benefits_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每周表现摘要`)
};

/**
* | output |
* | --- |
* | "Weekly performance summary" |
*
* @param {Directory_Promotion_Benefits_SummaryInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_benefits_summary = /** @type {((inputs?: Directory_Promotion_Benefits_SummaryInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_Benefits_SummaryInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_benefits_summary(inputs)
	return zh_directory_promotion_benefits_summary(inputs)
});
export { directory_promotion_benefits_summary as "directory.promotion.benefits.summary" }